/*
 * ===============================================================================================================
 *                                Copyright 2020, Blue Yonder Group, Inc.
 *                                           All Rights Reserved
 *
 *                               THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF
 *                                          BLUE YONDER GROUP, INC.
 *
 *
 *                         The copyright notice above does not evidence any actual
 *                                 or intended publication of such source code.
 *
 * ===============================================================================================================
 */
import { Box, Typography } from '@mui/material';
import { IErrorMessage } from '../../models/Common/ErrorMessage';

export const ErrorMessage = ({ message }: IErrorMessage) => {
  return (
    <Typography variant="body2">
      <Box id="error-message" component="span" color="error.main" fontWeight="fontWeightBold">
        {message}
      </Box>
    </Typography>
  );
};
